import { startSlidingPills } from '@ck/ui';
import { savedTheme } from './shell-bits';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import '@ck/ui/styles.css';
import { initClickSpark, initSpotlight } from '@ck/ui';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

document.documentElement.dataset.app = 'crm';
document.documentElement.dataset.theme = savedTheme();

initSpotlight();
initClickSpark();
startSlidingPills();
